/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */
    continue: 'Continue',
    optional: 'Optional',
    instructions: 'Instructions',
    no_results: 'No results',
    click_to_confirm: 'Click to confirm',
    caution: 'Caution',
    are_you_sure: 'Are you sure?',
    important: 'IMPORTANT',
    i_confirm: 'I confirm',

    /* Module special vocabulary */
    recipients: {
        menu: {
            index: 'Recipients',
            create: 'Create new recipient',
            list: 'List of recipients',
            recipients: 'Recipients'
        },
        table_titles: {
            id: 'ID',
            name: "Recipient's full name",
            description: 'Label',
            phone: 'Phone',
            address: "Recipient's address",
            currency: 'Currency',
            account_number: 'Account number',
            setting: 'Edit / Delete',
        },
        bank_accounts: {
            index: 'Recipient bank accounts',
            bank: 'Bank',
            type: 'Payment method',
            info_label1: 'Primary value',
            info_label2: 'Secondary value',
            setting: 'Delete',
            edit_form: 'Recipient\'s bank account edit form',
        },
        edit: 'Edit recipient',
        recipient_address_hint: "Recipient's residential address",
        confirm_recipient_currency: 'Confirm recipient\'s currency',
        select_recipient_currency: 'Select recipient\'s currency',
        notice1: 'You selected <b>{currency}</b> as your recipient\'s currency. If that\'s not intended, please return to first step and swap currencies.',
        details_for: 'Recipient\'s details for {country}',
        tick_if_recipients_account_name_for: 'Tick if Recipient\'s Account Name for <b>{outgoing_country}</b> is <b>{full_name}',
        full_name_of_account_holder: 'Full name of account holder',
        ideally_in_the_language_of: 'ideally in the language of',
        recipients_phone_number: 'Recipient\'s phone number',
        a_nickname_to_identify_this_recipient_in_your_list: 'A nickname to identify this recipient in your list',
        how_does_your_receiver_want: 'How does your receiver want {currency}?',
        by_deleting_this_recipient_all_related_bank_accounts_will_be_deleted: 'By deleting this recipient all related bank accounts will be deleted.',
        we_are_taking_you_to_the_recipients_page: 'We\'re taking you to the Recipients page.',
        once_you_are_done_with_recipients_you_ll_need_to_start: 'Once you\'re done with Recipients, you\'ll need to start over submitting your order.',
        exchange_rate_and_payment_amounts_will_be_locked: 'Exchange rate and payment amounts will be locked in, for your order. Please confirm the following',
        i_confirm_i_will_be_paying_from_my_bank_account: 'I confirm I will be paying from my bank account under my name: {name}',
        i_confirm_i_m_able_to_make_the_payment_asap: 'I confirm I\m able to make the payment ASAP.',
        edit_recipient: 'Edit recipient',
        go_to_recipients: 'GO TO RECIPIENTS',
        payment_method: 'Payment method',
        bank: 'Bank',
        bank_name: 'Bank name',
        add_more_accounts_for: 'Add more accounts for {name}',
        add_a_recipient: 'Add a recipient',
        accounts: 'Accounts',
        send_money: 'Send Money',
        add_an_account_for: 'Add an account for {name}',
        i_d_like_to: 'I\'d like to ...',
        edit_this_recipient_s_details: 'edit this recipient’s details',
        eg_account_number_is_wrong: 'Eg. Account number is wrong',
        switch_to_another_saved_recipient: 'switch to another saved recipient.',
        create_a_whole_new_recipient_first: 'create a whole new recipient first.',
        select_the_new_recipient: 'Select the new recipient',
        current_recipient: 'Current Recipient',
        update_order_and_recipient: 'UPDATE ORDER & RECIPIENT',
        update_order_s_recipient: 'UPDATE ORDER\'S RECIPIENT',
        oops_you_don_t_have_any_other_recipient_to_pick: 'Oops! You don\'t have any other recipient to pick.',
        edit_recipient_s_details: 'Edit recipient\'s details',
        recipient_bank: 'Recipient\'s bank',
        recipient_name: 'Recipient\'s name',
        recipient_info_was_updated_successfully: 'Recipient info was updated successfully!',
        inactive_bank: 'Inactive bank',
    }
}
